import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule, routes } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient } from '@angular/common/http';
import { LogoutComponent } from './features/logout/logout.component';
import { provideRouter, RouteReuseStrategy } from '@angular/router';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { AuthService } from './core/services/auth.service';
import { ConfirmationPopupComponent } from './shared/components/dialogs/confirmation-popup/confirmation-popup.component';
import { MatIconModule } from '@angular/material/icon';
import { AuthInterceptor } from './core/services/auth.interceptor';
import { DocsViewerComponent } from './shared/components/docs-viewer/docs-viewer.component';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { CustomSnackbarComponent } from './shared/components/snackbar/custom-snackbar.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { CustomRouteReuseStrategy } from './core/route-reuse-strategy';

export function initializeAuth(authService: AuthService) {
  return () => authService.initializeOAuth();
}

@NgModule({
  declarations: [
    AppComponent,
    LogoutComponent,
    ConfirmationPopupComponent,
    DocsViewerComponent,
    CustomSnackbarComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatIconModule,
    NgxDocViewerModule,
    MatSnackBarModule
  ],
  providers: [
    provideRouter(routes),
    provideHttpClient(),
    provideOAuthClient(),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAuth,
      multi: true,
      deps: [AuthService]
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: RouteReuseStrategy,
      useClass: CustomRouteReuseStrategy
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
